// project import
import other from './modules';
import { NavItemType } from 'types/menu';


// types

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [other]
};

export default menuItems;
